import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LegInfo } from '../../../models/route-summary.model';
import { formatDistance, formatDuration } from '../../../services/format-route';

// One hop of the route: how far and how long it is from the previous point in
// the plan to the stop rendered right below this row.
@Component({
  selector: 'app-leg-connector',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './leg-connector.component.html',
  styleUrl: './leg-connector.component.css',
})
export class LegConnectorComponent {
  readonly leg = input.required<LegInfo>();

  readonly label = computed(() => {
    const l = this.leg();
    return `${formatDistance(l.distanceMeters)} · ${formatDuration(l.durationSeconds)}`;
  });

  // The visible text says nothing about what it measures between, so spell it
  // out for screen readers.
  readonly ariaLabel = computed(() => {
    const l = this.leg();
    return `${formatDistance(l.distanceMeters)}, ${formatDuration(l.durationSeconds)} od prethodnog mesta`;
  });
}
